import { generateEndpointWithSearchFilter } from "@/utils/utils";
import { apiClientJSON } from "../apiClient";

export interface Referral {
  userId: number;
  code: string;
  username: string;
  email: string;
  phone: string;
  referralStatus: string;
}

export interface ReferralListResponse {
  content: Referral[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}

export interface ReferralListParams {
  page?: number;
  search?: string;
  sort?: string;
  filter?: string;
  size?: number;
}

export const getReferralsList = (
  params: ReferralListParams = {}
): Promise<ReferralListResponse> => {
  const {
    page = 0,
    search = "",
    sort = "id,desc",
    filter = "",
    size = 25,
  } = params;
  const endpoint = generateEndpointWithSearchFilter(
    `/coupon-service/dashboard/referral?size=${size}`,
    page,
    search,
    sort,
    filter
  );
  return apiClientJSON.get(endpoint).then((r) => r.data);
};

export const deleteReferral = (userId: number): Promise<void> => {
  return apiClientJSON
    .delete(`/coupon-service/dashboard/referral/${userId}`)
    .then(() => {});
};
